module.exports = __webpack_public_path__ + "img/PG.a53efb29.svg";